import React, { useContext } from 'react';
import { useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import { findT } from '@interness/web-core/src/components/_helpers';
import Button from '@interness/web-core/src/components/elements/Button/Button';
import Link from '@interness/web-core/src/components/elements/Link/Link';
import { LanguageContext } from '@interness/web-core/src/providers';
import routes from '@interness/web-core/config/routes';
import { getRandomBrandImage } from '@interness/brands-addon/src/components/_helpers';
import SplitImageSection from '@interness/web-core/src/components/structure/SplitImageSection/SplitImageSection';
import * as S from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
const orderTypes = (types, order) => {
  types.sort((a, b) => order.indexOf(a.type) - order.indexOf(b.type));
  return types;
};
const Display = _ref => {
  let {
    exclude,
    order,
    buttonPrimary,
    inserts,
    layout,
    textOverride
  } = _ref;
  const {
    brands,
    brand_types
  } = useStaticQuery(query);
  const {
    language
  } = useContext(LanguageContext);
  const usedTypes = [];
  brands.nodes.forEach(_ref2 => {
    let {
      brand
    } = _ref2;
    if (!usedTypes.includes(brand.type.type) && !exclude.includes(brand.type.type)) {
      usedTypes.push(brand.type.type);
    }
  });
  const displayTypes = orderTypes(brand_types.nodes.filter(brand_type => usedTypes.includes(brand_type.type)), order);
  if (layout === 'default') {
    return ___EmotionJSX(S.Container, null, displayTypes.map(displayType => {
      const translations = findT(displayType.translations, 'de');
      const image = getRandomBrandImage(brands.nodes, displayType.type, 'defaultImages');
      const override = textOverride[displayType.type];
      return ___EmotionJSX(S.Row, {
        key: displayType.type
      }, ___EmotionJSX("div", {
        className: "int-col int-textCol"
      }, ___EmotionJSX("h2", null, translations.display_name), override ? ___EmotionJSX("div", {
        dangerouslySetInnerHTML: {
          __html: override
        }
      }) : ___EmotionJSX("p", null, translations.short_description), ___EmotionJSX("div", {
        className: "int-btn"
      }, ___EmotionJSX(Button, {
        as: Link,
        primary: buttonPrimary,
        to: routes[displayType.type][language]
      }, "Mehr erfahren"))), ___EmotionJSX("div", {
        className: "int-col int-imageCol"
      }, ___EmotionJSX(Img, {
        fluid: image.defaultImages[0].file.localFile.childImageSharp.fluid,
        alt: image.display_name
      })));
    }), inserts && inserts.map(insert => ___EmotionJSX(S.Row, {
      key: insert.title
    }, ___EmotionJSX("div", {
      className: "int-col int-textCol"
    }, ___EmotionJSX("h2", null, insert.title), ___EmotionJSX("div", {
      dangerouslySetInnerHTML: {
        __html: insert.description
      }
    }), ___EmotionJSX("div", {
      className: "int-btn"
    }, ___EmotionJSX(Button, {
      as: Link,
      primary: buttonPrimary,
      to: insert.link
    }, "Mehr erfahren"))), ___EmotionJSX("div", {
      className: "int-col int-imageCol"
    }, ___EmotionJSX(Img, {
      fluid: insert.image,
      alt: insert.title
    })))));
  }
  if (layout === 'square') {
    return ___EmotionJSX(React.Fragment, null, inserts && inserts.map((insert, i) => ___EmotionJSX(SplitImageSection, {
      heading: insert.title,
      image: insert.image,
      imagePosition: i % 2 ? 'right' : 'left',
      key: insert.title
    }, ___EmotionJSX("div", {
      dangerouslySetInnerHTML: {
        __html: insert.description
      }
    }), ___EmotionJSX(Button, {
      as: Link,
      primary: buttonPrimary,
      to: insert.link
    }, "Mehr erfahren"))), displayTypes.map((displayType, i) => {
      const translations = findT(displayType.translations, 'de');
      const image = getRandomBrandImage(brands.nodes, displayType.type, 'squareImages');
      const override = textOverride[displayType.type];
      return ___EmotionJSX(SplitImageSection, {
        heading: translations.display_name,
        image: image.squareImages[0].file.localFile,
        imagePosition: i % 2 ? 'left' : 'right',
        key: displayType.type
      }, override ? ___EmotionJSX("div", {
        dangerouslySetInnerHTML: {
          __html: override
        }
      }) : ___EmotionJSX("p", null, translations.short_description), ___EmotionJSX(Button, {
        as: Link,
        primary: buttonPrimary,
        to: routes[displayType.type][language]
      }, "Mehr erfahren"));
    }));
  }
};
Display.defaultProps = {
  exclude: [''],
  order: [''],
  layout: 'default',
  textOverride: {}
};
const query = "632061493";
export default Display;